import { createFileRoute, redirect } from '@tanstack/react-router';
import { meQuery } from '@/lib/session';
import { setLanguage } from '@/i18n';
import { setFormatPreferences } from '@/lib/format';
import { AppShell } from '@/components/app-shell';

// Every signed-in page lives under this layout: it loads the caller once and sends anonymous visitors to /login.
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    if (!me) throw redirect({ to: '/login', search: { redirect: location.href } });
    // A client user only has the portal (ADR-0028).
    if (me.kind === 'client') throw redirect({ to: '/portal' });
    setLanguage(me.locale);
    setFormatPreferences(me);
    return { me };
  },
  component: AppShell,
});
